<div
  class="adv-feas-container"
  [ngStyle]="{
    'background-color': headerFeasibility.isOpen ? 'white' : '#333'
  }"
>
  <button
    psUiButton
    class="header-div-h6 position-relative header-dropdown button-advance-feas"
    [class.show]="!!headerFeasibility && headerFeasibility.isOpen"
    [ngClass]="{
      'dropdown-toggle': !(multiCountrySelected && !draftSaved)
    }"
    color="secondary"
    [disabled]="disableFeasibilityDropdown"
    [psUiDropdownToggleFor]="headerFeasibility"
    psUiGtagEvent
    trackOn="click"
    action="feasibility"
    category="Black_Bar"
    [params]="{ event_label: 'Feasibility Dropdown' }"
  >
    {{
      multiCountrySelected && !draftSaved
        ? Constants.TOTAL_FEASIBILITY
        : Constants.FEASIBILITY
    }}
    <span
      *ngIf="feasibilityStatus !== 'none'"
      [ngClass]="'bg-' + feasibilityStatus"
      class="position-absolute translate-middle p-2 bg-success badge-ball border border-light rounded-circle margin-left pointer-position border-0"
    >
      <span class="visually-hidden">New alerts</span>
    </span>
  </button>

  <ps-ui-dropdown
    #headerFeasibility="psUiDropdown"
    class="header-dropdown drop-panel"
    (isClose)="closeDropdown($event)"
  >
    <div (click)="avoidClose($event)">
      <div class="first_panel bor_bottom min-150">
        <!-- AUDIENCE SECTION -->
        <ps-ui-accordion [closeOthers]="true">
          <ps-ui-accordion-section
            class="adv-feas"
            title="Audience"
            [isExpanded]="true"
          >
            <div class="default-quotas m-0 fw-normal" title="">
              <div
                *ngFor="let audience of audienceDetails"
                class="qualification-condition"
              >
                <strong>{{ audience.qualification }}: </strong>
                <span title="{{ audience.conditions }}">{{
                  audience.conditions
                }}</span>
              </div>
            </div>
          </ps-ui-accordion-section>
        </ps-ui-accordion>
      </div>

      <!-- QUOTA SECTION -->
      <div
        class="min-150 feas-quota-section"
        [ngClass]="filteredAudienceSection ? 'bor_bottom' : 'quota-border'"
      >
        <ps-ui-accordion [closeOthers]="true">
          <ps-ui-accordion-section
            class="adv-feas"
            title="Quotas"
            [isExpanded]="true"
          >
            <div class="scrollable-content" title="">
              <div class="text-center" *ngIf="feasibilityQuota.length === 0">
                <p>Add qualification quota to show the information</p>
              </div>

              <ng-container *ngIf="feasibilityQuota.length > 0">
                <table
                  class="table survey-detail-table quota-detail-section mb-0"
                  *ngFor="
                    let feasQuota of parsedFeasibilityQuota
                      | sort : 'qualificationCode';
                    let $index = index
                  "
                  aria-label="Quota View Table"
                >
                  <thead>
                    <tr class="tr-quotas-header">
                      <th
                        [psUiSortTable]="feasQuota.quotas"
                        data-order=""
                        data-name="range"
                        class="text-left name-th"
                      >
                        {{ feasQuota.name }}
                      </th>
                      <th class="align-text">Feasible</th>
                      <th class="align-text">Desired</th>
                      <th class="align-text">Difference</th>
                    </tr>
                  </thead>
                  <tbody
                    class="supplier-quota-accordion-tbl body mx-2 px-1 p-1 mb-0"
                  >
                    <tr
                      *ngIf="feasQuota.showQualificationMessage"
                      class="feasibility-message"
                    >
                      <td
                        class="unknown-tr text-center p-2 my-2 border border-1 border-white"
                        colspan="4"
                      >
                        Population Data is Unavailable
                      </td>
                      <br />
                    </tr>
                    <tr
                      *ngFor="let quota of feasQuota.quotas; let $index = index"
                      [ngClass]="{
                        'unknown-tr': !quota.feasible
                      }"
                    >
                      <td class="text-left name-th">
                        {{ quota.range }}
                      </td>
                      <td class="text-right align-text">
                        {{ quota.feasibiltyValue }}
                      </td>
                      <td class="text-right align-text">
                        {{ quota.desiredFeasibilty }}
                      </td>
                      <td class="text-right align-text">
                        {{ quota.feasibiltyDifference }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </ng-container>
            </div>
            <div
              *ngIf="isShowExclusionCheckbox"
              class="exclusion-check"
              title=""
            >
              <input
                [ngClass]="{ 'disabled-checkbox': isDisabledExclusionCheckBox }"
                type="checkbox"
                [ngModel]="filterFeasibilityAudience"
                (ngModelChange)="onFilterFeasibilityAudience($event)"
                [readOnly]="isDisabledExclusionCheckBox"
                (click)="showCheckBoxAlert($event)"
              />
              Remove my exclusions from the feasible audience
            </div>
          </ps-ui-accordion-section>
        </ps-ui-accordion>
      </div>

      <!-- FILTERED AUDIENCE SECTION -->
      <div
        id="filtered-audience"
        class="min-150 bot-padd no-overflow"
        *ngIf="filteredAudienceSection"
      >
        <ps-ui-accordion
          [closeOthers]="true"
          (toggle)="toggleAccordion($event)"
        >
          <ps-ui-accordion-section
            class="adv-feas"
            title="Advanced Filters"
            [isExpanded]="false"
          >
            <!-- TYPE SUB-SECTION (Exclusion/Inclusion)  -->
            <div class="form-group row mb-space" title="">
              <div class="col-sm-2 left-align-text">
                <label class="col-form-label-sm pull-right">Type</label>
              </div>
              <div class="col-sm-10 feasibility-type">
                <ps-ui-select-dropdown
                  [field]="'name'"
                  [dropdownItems]="feasibilityTypes"
                  [eventListeningContext]="elementReferenceName"
                  labelAlignment="start"
                  [(ngModel)]="selectFeasibilityType"
                  [enableSearch]="false"
                  (selectedItem)="onFeasibilityTypeChange($event)"
                  class="input-group criteria-dropdown feasibility-type-drop-down"
                >
                </ps-ui-select-dropdown>
              </div>
            </div>

            <!-- DATE RANGE SUB-SECTION -->
            <div
              class="form-group row date-range-project sub-section-margin mb-space"
            >
              <div class="col-sm-2 left-align-text date-range-label">
                <label class="col-form-label-sm pull-right">Dates</label>
              </div>
              <div class="col-sm-10">
                <div
                  name="daterangeInput"
                  #dateRangeFilterRef
                  class="input-group"
                  daterangepicker
                  [options]="options"
                  (selected)="selectedDate($event)"
                  (cancelDaterangepicker)="cancelDateRange()"
                  (click)="setClassDateRange()"
                >
                  <span class="form-control uneditable-input">
                    {{
                      dateRange.start && dateRange.end
                        ? ''
                        : 'Select date range'
                    }}
                    {{ dateRange.start | date : 'MMMM dd yyyy' }}
                    {{ dateRange.end | date : 'MMMM dd yyyy' }}
                  </span>
                </div>
              </div>
            </div>

            <!-- CRITERIA SUB-SECTION -->
            <div class="form-group row mb-space" title="">
              <div class="col-sm-2 left-align-text">
                <label class="col-form-label-sm pull-right">Criteria</label>
                <div class="fa fa-info-circle setting-info">
                  <p>
                    <span>
                      If you use different "criteria", the system auto-select
                      CLOSED and INVOICED survey and combine them using the
                      followin logics:
                      <br />
                      <br />
                      <ul>
                        <li>
                          OR logic between the different OPTIONS for the same
                          CRITERIA
                        </li>
                        <li>AND logic between different CRITERIA</li>
                      </ul>
                    </span>
                  </p>
                </div>
              </div>
              <div class="col-sm-10 feasibility-type feas-criteria">
                <div class="row pb-2">
                  <div class="col-12" class="criteria-div">
                    <ps-ui-select-dropdown
                      [field]="'name'"
                      [dropdownItems]="advanceFeasibilityCriterias"
                      [eventListeningContext]="elementReferenceName"
                      labelAlignment="start"
                      [(ngModel)]="selectedCriteria"
                      [enableSearch]="false"
                      (selectedItem)="onCriteriaChange($event)"
                      class="criteria-dropdown"
                      [labelNone]="'Select criteria'"
                    >
                    </ps-ui-select-dropdown>
                  </div>
                </div>
                <div class="row">
                  <div
                    *ngIf="
                      !selectedCriteria.id ||
                      selectedCriteria.filterType === filterType.INPUT
                    "
                    class="col-12 billing-number"
                  >
                    <input
                      id="billingSearchKey"
                      type="text"
                      placeholder="{{
                        selectedCriteria.filterType === filterType.INPUT
                          ? 'Type Billing number...'
                          : ''
                      }}"
                      class="input-group"
                      autocomplete="off"
                      [(ngModel)]="billingNumberSearchKeyword"
                      (keyup)="
                        onBillingNumberSearchKeyUp(billingSearchKey.value)
                      "
                      [disabled]="!selectedCriteria.id"
                      #billingSearchKey
                    />
                    <ps-ui-ellipsis-loader
                      class="billing-number-loader"
                      [show]="showLoaderForBillingNumber"
                    >
                    </ps-ui-ellipsis-loader>

                    <div
                      *ngIf="showBillingNumberDropDown"
                      class="billing-drop-down"
                    >
                      <div
                        *ngFor="let billingNumber of billingNumberList"
                        class="search-results billing-drop-down-item"
                      >
                        <span>
                          <input
                            type="checkbox"
                            class="form-check-input"
                            (change)="selectBillingNumber(billingNumber)"
                            [checked]="
                              findSelectedBillingNumberIndex(billingNumber) > -1
                            "
                          />
                        </span>
                        {{ billingNumber }}
                      </div>
                      <div
                        *ngIf="!hasBillingSurveys"
                        class="search-results billing-drop-down-item"
                      >
                        No result
                      </div>
                      <div class="billing-drop-down-button bg-white">
                        <li>
                          <span class="d-flex justify-content-around">
                            <button
                              [disabled]="!selectedBillingNumbers.length"
                              type="button"
                              psUiButton
                              color="primary"
                              class="btn footer-button"
                              (click)="onSubmitBillingNumber()"
                            >
                              Confirm
                            </button>
                          </span>
                        </li>
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="
                      selectedCriteria.filterType === filterType.SELECT_DROPDOWN
                    "
                    class="col-12 template-dropdown-div"
                  >
                    <ps-ui-select-dropdown
                      [multi]="true"
                      [dropdownItems]="projectManagers"
                      [field]="'name'"
                      [idField]="'id'"
                      [clearSearch]="false"
                      class="criteria-dropdown"
                      [labelNone]="ProjectManagerLabel"
                      labelAlignment="start"
                      [newTextInput]="true"
                      [showNewTextField]="false"
                      [newTextSelectionType]="'button'"
                      [eventListeningContext]="elementReferenceName"
                      [newInputLabel]="'Confirm'"
                      [(ngModel)]="selectedProjectManagers"
                      (submitButtonClicked)="onSubmitProjectManager()"
                      (selectedItems)="onProjectManagerChange($event)"
                    >
                    </ps-ui-select-dropdown>
                  </div>

                  <div
                    *ngIf="
                      selectedCriteria.filterType === filterType.TREE_DROPDOWN
                    "
                    class="col-12 template-dropdown-div"
                  >
                    <ps-ui-tree-dropdown
                      class="template-dropdown"
                      [labelNone]="'Select Template'"
                      labelAlignment="start"
                      [dropdownItems]="templates"
                      [folderOption]="templateFolderOption"
                      [fileOption]="templateOption"
                      (selectedFiles)="selectedTemplates($event)"
                      [multi]="true"
                      [showFooterSelectButton]="true"
                      [showFolderArrowIcon]="true"
                      [addNewFolder]="true"
                      [isFirstFooterButton]="false"
                      [footerSelectButtonText]="'Confirm'"
                    ></ps-ui-tree-dropdown>
                  </div>
                </div>

                <div
                  *ngIf="!!filters.length"
                  class="row form-group filter-groups pt-2"
                >
                  <div class="col-12 d-grid">
                    <span *ngFor="let filter of filters; let i = index">
                      <b
                        class="filter-criteria-name"
                        *ngIf="filter.selectedLists.length"
                        >{{ i !== 0 ? 'AND' : '' }} {{ filter.criteria }}:</b
                      >
                      <ul class="p-0" *ngFor="let item of filter.selectedLists">
                        <li
                          class="selected-group-list data-survey-li"
                          *ngIf="item"
                        >
                          {{ item }}
                          <a (click)="removeFilter(item, filter.criteria)">x</a>
                        </li>
                      </ul>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- GROUPS SUB-SECTION -->
            <div
              class="form-group row survey-groups sub-section-margin mb-space"
              title=""
            >
              <div class="col-sm-2 left-align-text survey-groups-label">
                <label class="col-form-label-sm pull-right">Groups</label>
              </div>
              <div class="col-sm-10" tabindex="1" (blur)="openDropDown(false)">
                <div
                  class="center search-bar-div col-sm-10 survey-group-list-input-div input-box-group"
                  [ngClass]="{
                    groupslist: !surveyGroupList
                  }"
                >
                  <input
                    id="searchKey"
                    type="number"
                    placeholder="Start typing to add groups"
                    min="0"
                    (click)="openDropDown()"
                    class="group-input"
                    autocomplete="off"
                    [(ngModel)]="searchKeyword"
                    (keyup)="onSearchKeyUp(searchKey.value)"
                    #searchKey
                  />
                  <ps-ui-ellipsis-loader
                    class="bouncing-loader"
                    [show]="showLoaderForSelectLocation"
                  >
                  </ps-ui-ellipsis-loader>
                  <div>
                    <div class="clearfix"></div>
                    <div
                      *ngIf="showDropDown"
                      class="search-drop-down center search-result-dropdown"
                    >
                      <div
                        *ngFor="let survey of surveyGroupList"
                        (click)="selectSurvey(survey)"
                        class="search-results"
                      >
                        <a>
                          <span>{{ survey.id }}</span>
                          <span class="survey-st-text">{{
                            survey.st_text
                          }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <ul
                  class="list-inline list-unstyled center selected-group-ul"
                  [ngClass]="'!surveyGroupList' ? 'hide-div' : 'show-div'"
                >
                  <ng-container
                    *ngFor="let item of allSurveyGroups; let i = index"
                  >
                    <li
                      class="selected-group-list data-survey-li"
                      *ngIf="item.id"
                      [attr.data-index]="i"
                    >
                      {{ item.id }}
                      <p class="data-survey-title" *ngIf="item.tle">
                        {{ item.tle }}
                      </p>
                      <a (click)="removeSurveyObject(item)">x</a>
                    </li>
                  </ng-container>
                </ul>
              </div>
            </div>

            <!-- SUMMARY SUB-SECTION -->
            <div
              class="form-group row sub-section-margin margin-bottom-less mb-space"
              title=""
            >
              <div
                class="col-sm-2 left-align-text left-align-text survey-groups-label"
              >
                <label class="col-form-label-sm pull-right">Summary</label>
              </div>
              <div class="col summary-filter">
                <ng-container
                  *ngIf="
                    selectFeasibilityType.name ===
                    Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.EXCLUDE
                  "
                >
                  <p class="col-form-label-sm">
                    <span class="bold-text">
                      {{
                        psidCountObj.total_count || 0 | number : '1.0-0'
                      }}</span
                    >
                    Respondents have been
                    <span class="bold-text">Excluded</span> in this project
                    across
                    <span class="bold-text">{{ allSurveyGroups.length }}</span>
                    projects
                  </p>
                </ng-container>

                <ng-container
                  *ngIf="
                    selectFeasibilityType.name ===
                    Constants.ADVANCE_FEASIBILITY.FEASIBILITY_TYPE.INCLUDE
                  "
                >
                  <p class="col-form-label-sm">
                    <span class="bold-text">
                      {{ psidCountObj.total_count || 0 | number : '1.0-0' }}
                    </span>
                    Respondents have been
                    <span class="bold-text">Included</span> in this project
                    across
                    <span class="bold-text">{{ allSurveyGroups.length }}</span>
                    projects
                  </p>
                </ng-container>
              </div>
              <div class="reset-audience col-md-11 offset-md-1">
                <button
                  psUiButton
                  (click)="resetFilteredAudience()"
                  class="reset-button-audience"
                >
                  Reset Filtered Audience
                </button>
              </div>
            </div>
          </ps-ui-accordion-section>
        </ps-ui-accordion>
      </div>
    </div>
  </ps-ui-dropdown>
  <div class="mb-0">
    <span
      *ngIf="!loading"
      class="header-div-span"
      [ngStyle]="{ color: headerFeasibility.isOpen ? 'black' : 'white' }"
    >
      {{ totalFeasibility | number }}
    </span>
    <ps-ui-ellipsis-loader [show]="loading"> </ps-ui-ellipsis-loader>
  </div>
</div>
